import { render, staticRenderFns } from "./lbpp.vue?vue&type=template&id=2c537e1a&"
import script from "./lbpp.vue?vue&type=script&lang=js&"
export * from "./lbpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports